import React from "react";

// Every page sits inside this. Horizontal padding steps 16 / 24 / 32px per the
// design system §4 — pages must not re-declare their own padding.
const Container = ({ as: Tag = "div", width = "default", className = "", children }) => (
  <Tag
    className={`mx-auto w-full px-4 md:px-6 lg:px-8 ${
      width === "prose" ? "max-w-prose" : "max-w-container"
    } ${className}`}
  >
    {children}
  </Tag>
);

export default Container;
